export default "__VITE_ASSET__CuHZ$7hZ__"